import events from './events';

// if ('serviceWorker' in navigator) {
//     window.addEventListener('load', () => {
//         navigator.serviceWorker.register('/sw.js')
//         .then(reg => {})
//         .catch(err => console.log('service worker not registered', err));
//     });
// }

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
  }


//User Register Function
window.oms_UserRegisterFn = events.UserRegisterFn;

new events.GetSettings().load();
new events.GetLanguage().load();
new events.GetFilters().load();
new events.GetOpeningHours().load();
new events.UserLogin().load();
new events.GetCategories().load();
new events.GetBaseCategories().load();
new events.GetProductList().load();
new events.GetCountryList().load();
new events.UserRegister().load();
new events.GetProduct().load();
new events.GetAdditionalCharges().load();
new events.GetValidateCart().load();
new events.GetCartOffers().load();
new events.UserProfile().load();
new events.GetCityList().load();
new events.GetShippingPrimaryPrice().load();
new events.GetShippingSecondaryPrice().load();
new events.CalculateOpeningHours().load();
new events.GetLoyaltyPoints().load();
new events.SaveOrderInfo().load();
new events.GetOrderInfo().load();
new events.GetUserData().load();
new events.GetCartProducts().load();
new events.UpdateCart().load();
new events.CalculateLoyaltyPoints().load();
new events.SubmitOrder().load();
new events.ChangeLocation().load();
new events.GetCurrentLocation().load();
new events.ProceedToPayment().load();
new events.UserProfileEdit().load();
new events.UserChangePassword().load();
new events.UserChangeProfileImage().load();
new events.UserLogout().load();
new events.GetOrderHistory().load();
new events.GetCheckoutStatus().load();
new events.UpdateCheckoutStatus().load();
new events.ValidateDiscountCode().load();
new events.GetDiscountCode().load();
new events.UpdateDiscountCode().load();
new events.UserForgotPassword().load();
new events.UserResetPassword().load();
new events.GetPaymentMethods().load();
new events.GetSpecificProducts().load();
new events.GetBestSellingProducts().load();
new events.GetOfferProducts().load();
new events.GetAddresses().load();
new events.GetAddress().load();
new events.SaveAddress().load();
new events.EditAddress().load();
new events.DeleteAddress().load();
new events.SetDefaultAddress().load();
new events.getFacertData().load();
new events.getFilterProduct().load();
new events.GetQuantityBasePriceModule().load();
new events.GetAbandonedCart().load();
new events.StoreCart().load();
new events.GetCategroy().load();
new events.GetCategroyByProduct().load();
new events.GetCategroyByCode().load();
new events.GetTemplateList().load();
new events.GetSocialProviders().load();
new events.SetSocialAuth().load();
new events.GetCmsPageContent().load();
new events.VerifyOtp().load();
